var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.asyncLoading)?_c('div',{staticClass:"subscription-flow-v2"},[(_vm.isPayment)?_c('purchase-offering-payment',{attrs:{"done":_vm.goToDone}}):_c('purchase-offering-done')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }